import { render, staticRenderFns } from "./AddChatIcon.vue?vue&type=template&id=654df42e&scoped=true&"
import script from "./AddChatIcon.vue?vue&type=script&lang=js&"
export * from "./AddChatIcon.vue?vue&type=script&lang=js&"
import style0 from "./AddChatIcon.vue?vue&type=style&index=0&id=654df42e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654df42e",
  null
  
)

export default component.exports